<template>
    <div class="loader">
        <div
            class="inner"
            :class="{
                'text-6xl': size === '2xl',
                'text-5xl': size === 'xl',
                'text-4xl': !size || size === 'lg',
                'text-2xl': size === 'md',
                'text-xl': size === 'sm'
            }"
        >
            <i class="fad fa-spinner-third fa-spin" />
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}>();
</script>

<style lang="scss" scoped>
i {
    font-size: inherit;
}

.loader {
    @apply mx-auto p-4 text-blue-600;
}

.inner {
    &.text-6xl {
        @apply text-[3.75rem];
    }

    &.text-5xl {
        @apply text-[3rem];
    }

    &.text-4xl {
        @apply text-[2.25rem];
    }

    &.text-2xl {
        @apply text-[1.5rem];
    }

    &.text-xl {
        @apply text-[1.25rem];
    }
}
</style>
